<div>
    <h2 mat-dialog-title>Change Status</h2>
    <div>
        <form [formGroup]="statusChangeForm">
            <div fxLayout="column" fxLayout.gt-sm="column" fxLayoutGap.gt-sm="10px">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option *ngFor="let item of status" [value]="item?.statusName">{{item?.statusName}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="statusChangeForm.controls['status'].touched && statusChangeForm.controls['status'].hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>
           
            
              <mat-form-field fxFlex="auto" appearance="outline"  class="fullwidth">
                <mat-label>Notes</mat-label>
                <textarea matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="5" 
                          formControlName="note"></textarea>
                          <mat-error  *ngIf="statusChangeForm.controls['note'].touched && statusChangeForm.controls['note'].hasError('required')">
                            This is required field.
                        </mat-error>
              </mat-form-field>
            </div>
                

        </form>
        <!-- <div>
            <button mat-button cdkFocusInitial (click)="changeStatus()">Change</button>
            <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>   
        </div>   -->


        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        
            <button mat-button class="sub-button" (click)="changeStatus()"><span>Change</span></button>
            <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()"><span>Close</span></button>
        </div>
    </div>
</div>
